import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';
import { NavLink } from 'react-router-dom';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';

export default class Remittance extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'remittance',
            id: props.Id,
            isNew: props.IsNew,
            io: props.IO,
            data: null,
            loading: true,
            bodyVersion: '',
            t_amount: 0,
            t_total: 0,
            buyinvoise: null
        };
    }
    componentDidMount() {
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/remittance/get", {
            id: this.getCurrentFormId(),
            io: this.state.io,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.io = data.record.io;
                    window.companyId = data.global.company.id;

                    for (var i = 0; i < data.bodies.length; i++) {
                        this.state.t_amount += data.bodies[i]["amount"];
                        this.state.t_total += data.bodies[i]["total"];
                    }

                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e, withDocument = false) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.customerMoein)) this.state.data.record.customerMoein = 0;

        this.httpPost("api/v1/remittance/save", {
            withDocument: withDocument,
            companyId: this.state.data.global.company.id,
            id: this.state.data.record.id,
            io: this.state.data.record.io,
            number: this.state.data.record.number,
            description: this.state.data.record.description,
            datePersian: this.state.data.record.datePersian,
            customerId: this.state.data.record.customerId,
            type: this.state.data.record.type,
            customerMoein: this.state.data.record.customerMoein,

            bodies: this.state.data.bodies,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {

                    if (this.state.data.record.io == 2) {
                        this.showSuccessMessage("حواله انبار با شماره " + data.number + " با موفقیت ثبت شد.");
                        this.setState({
                            redirect: '/remittances/out/'
                        });
                    }
                    if (this.state.data.record.io == 1) {
                        this.showSuccessMessage("رسید انبار با شماره " + data.number + " با موفقیت ثبت شد.");
                        this.setState({
                            redirect: '/remittances/in/'
                        });
                    }
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setBodyValue(id, field, value) {
        this.state.t_amount = 0;
        this.state.t_total = 0;

        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                if (field == 'stuffId') {
                    this.state.data.bodies[i][field] = value.value;
                }
                else {
                    this.state.data.bodies[i][field] = value;
                }

                if (this.isBlank(this.state.data.bodies[i]["amount"])) this.state.data.bodies[i]["amount"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["price"])) this.state.data.bodies[i]["price"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["total"])) this.state.data.bodies[i]["total"] = 0;

                if (field == 'stuffId') {
                    if (value != null) this.state.data.bodies[i]["unitId"] = value.unitId;
                    if (value != null) this.state.data.bodies[i]["price"] = value.price;
                }

                this.state.data.bodies[i]["total"] = this.FixedPointNumber(this.state.data.bodies[i]["price"] * this.state.data.bodies[i]["amount"]);
            }

            this.state.t_amount = this.FixedPointNumber(this.state.data.bodies[i]["amount"] + this.state.t_amount);
            this.state.t_total = this.FixedPointNumber(this.state.data.bodies[i]["total"] + this.state.t_total);

        }
        this.setState({ bodyVersion: this.uuidv4() });
    }
    newBodyRow(e) {
        e.preventDefault();
        this.state.data.bodies.push({
            id: this.uuidv4(),
            stuffId: 0,
            unitId: 0,
            warehouseId: this.defaultGuid(),
            amount: 1,
            price: 0,
            total: 0,
        });
        this.setState({ data: this.state.data });
    }
    removeBodyRow(e, id) {
        e.preventDefault();
        var temp = [];
        this.state.data.bodies.forEach(r => {
            if (r.id != id) temp.push(r);
        });
        this.state.data.bodies = temp;
        this.setState({ data: this.state.data });
    }
    loadPersonsOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getpersons/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadStuffsOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getstuffs/", {
                method: "post",
                body: JSON.stringify({
                    "type": 1,
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name + " " + _record.taxNumber,
                            price: _record.price,
                            unitId: _record.unitId,
                            vra: _record.taxRate
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadAccountOptions(inputValue, callback, type, parentCode) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getaccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "type": 3,
                    "parentCode": 0,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.fullCode,
                            label: _record.title,
                            moeinDetailed: _record.detailed
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    shaneSendToTax(checked) {
        this.state.data.record.sendToTax = checked;
        this.setState({ data: this.state.data });
    }
    RemoveDocument(id) {
        this.httpPost("api/v1/document/remove", {
            source: 1,
            id: id,
            companyId: (this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.data.document = null;
                    this.setState({ data: this.state.data });
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }


    calculateTotals = (bodies) => {
        let totalAmount = 0;
        let totalPrice = 0;

        bodies.forEach(body => {
            totalAmount += body.amount;
            totalPrice += body.price;
        });

        this.setState({
            t_amount: totalAmount,
            t_total: totalPrice
        });
    }


    loadBuyInvoiceOptions = (inputValue, callback) => {
        const requestData = {
            page: 1,
            count: 10,
            phrase: inputValue,
            filters: {
                mtype: 2, // مقدار مورد نظر را تنظیم کنید
                type: 0,  // مقدار مورد نظر را تنظیم کنید
                inp: 0,   // مقدار مورد نظر را تنظیم کنید
                ins: 0    // مقدار مورد نظر را تنظیم کنید
            }
        };

        fetch(`api/v1/invoice/buyinvoicelist`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === -2) {
                    // کاری انجام ندهید یا پیام مناسب نمایش دهید
                } else if (data.status === 1) {
                    const options = data.records.map(record => ({
                        value: record.id,
                        label: `${record.inno} - ${record.customerName}`
                    }));
                    // فراخوانی callback
                    callback(options);
                } else {
                    // پیام مناسب نمایش دهید
                }
            })
            .catch(error => {
                console.error("خطا در درخواست:", error);
            });
    }
    handleBuyInvoiceChange = (selectedOption) => {
        if (selectedOption) {
            const requestData = {
                id: selectedOption.value,
                inp: 0,  // مقدار مورد نظر را تنظیم کنید
                ins: 0,  // مقدار مورد نظر را تنظیم کنید
                isNew: false,
                mtype: 2  // مقدار مورد نظر را تنظیم کنید
            };

            fetch('api/v1/invoice/buyinvoiceget', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === -2) {
                        // کاری انجام ندهید یا پیام مناسب نمایش دهید
                    } else if (data.status === 1) {
                        // استخراج مقادیر مورد نیاز از bodies
                        const bodies = data.bodies.map(body => ({
                            warehouseId: body.warehouseId,
                            unitId: body.unitId,
                            stuffId: body.stuffId,
                            stuffName: body.stuffName,
                            total: body.prdis,
                            amount: body.am,  // amount
                            price: body.fee // price
                        }));

                        // ذخیره‌سازی مقادیر استخراج شده در state
                        this.setState(prevState => ({
                            data: {
                                ...prevState.data,
                                bodies: bodies,
                                record: {
                                    ...prevState.data.record,
                                    customerName: data.record.customerName,
                                    customerId: data.record.customerId
                                }
                            }
                        }), () => {
                            // فراخوانی تابع محاسبه پس از به‌روزرسانی state
                            this.calculateTotals(bodies);
                        });

                        console.log('داده‌های فاکتور خرید:', bodies);
                        console.log('نام مشتری و شناسه مشتری:', data.record.customerName, data.record.customerId);
                    } else {
                        // پیام مناسب نمایش دهید
                    }
                })
                .catch(error => {
                    console.error("خطا در درخواست:", error);
                });
        } else {
            // اگر هیچ گزینه‌ای انتخاب نشد، می‌توانید کاری انجام دهید یا پیام مناسب نمایش دهید
        }
    }







    renderForm() {
        console.log(this.state)
        return (
            <form onSubmit={e => this.save(e, false)} className="row g-4">
                <div className="nk-block-head">
                    <div className="nk-block-between g-3">
                        <div className="nk-block-head-content">
                            {this.state.io == 1 && <h3 className="nk-block-title page-title">رسید انبار</h3>}
                            {this.state.io == 2 && <h3 className="nk-block-title page-title">حواله انبار</h3>}
                        </div>
                        <div className="nk-block-head-content">
                            {!this.isNull(this.state.data.document) ?
                                <div className="me-2 dropdown">
                                    <a href="#" className="btn btn-primary" data-bs-toggle="dropdown"><span>سند شماره {this.state.data.document.number}</span><em className="icon ni ni-chevron-down"></em></a>
                                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-auto mt-1">
                                        <ul className="link-list-plain">
                                            <li><NavLink to={"/document/edit/" + this.state.data.document.id}>مشاهده سند</NavLink></li>
                                            <li><a className="hand" onClick={e => this.RemoveDocument(this.state.data.document.id)}>حذف سند</a></li>
                                        </ul>
                                    </div>
                                </div>
                                :
                                this.state.io == 2 ? <a className="me-2 hand btn btn-warning" onClick={e => this.save(null, true)}>صدور سند</a> : null
                            }
                            {this.state.io == 1 && <NavLink to="/remittances/in/" className="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em className="icon ni ni-arrow-left"></em><span>برگشت</span></NavLink>}
                            {this.state.io == 1 && <NavLink to="/remittances/in/" className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"><em className="icon ni ni-arrow-left"></em></NavLink>}
                            {this.state.io == 2 && <NavLink to="/remittances/out/" className="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em className="icon ni ni-arrow-left"></em><span>برگشت</span></NavLink>}
                            {this.state.io == 2 && <NavLink to="/remittances/out/" className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"><em className="icon ni ni-arrow-left"></em></NavLink>}
                        </div>

                    </div>
                </div>
                <div className="card card-bordered card-preview">
                    <div className="card-inner">
                        <ul className="nav nav-tabs mt-n3">
                            <li className="nav-item">
                                {this.state.io == 2 && <a className="nav-link active" data-bs-toggle="tab" href="#header"><em className="icon ni ni-info"></em><span>اطلاعات حواله انبار</span></a>}
                                {this.state.io == 1 && <a className="nav-link active" data-bs-toggle="tab" href="#header"><em className="icon ni ni-info"></em><span>اطلاعات رسید انبار</span></a>}
                            </li>
                            <li className="nav-item">
                                {this.state.io == 2 && <a className="nav-link" data-bs-toggle="tab" href="#bodies"><em className="icon ni ni-list-round"></em><span>اقلام حواله انبار</span></a>}
                                {this.state.io == 1 && <a className="nav-link" data-bs-toggle="tab" href="#bodies"><em className="icon ni ni-list-round"></em><span>اقلام رسید انبار</span></a>}
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div className="tab-pane active" id="header">
                                <div className="row">
                                    {this.state.io == 1 && <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="form-label">معین طرف حساب</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    style={{ "width": "100%" }}
                                                    defaultValue={!this.isNull(this.state.data.record.customerMoeinAccount) ? [{ value: this.state.data.record.customerMoeinAccount.fullCode, label: this.state.data.record.customerMoeinAccount.title }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب معین طرف حساب"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                    onChange={e => this.state.data.record.customerMoein = e.value}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.io == 1 &&
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="form-label">{this.state.io == 2 ? "مشتری" : "تامین کننده"}</label>
                                                <div className="form-control-wrap">
                                                    <SelectAsync
                                                        key={this.state.data.record.customerId || 'default'} // افزودن key منحصر به فرد
                                                        defaultValue={this.state.data.record.customerId ? { value: this.state.data.record.customerId, label: this.state.data.record.customerName } : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب ..."
                                                        defaultOptions
                                                        loadOptions={this.loadPersonsOptions}
                                                        onChange={selectedOption => {
                                                            let newRecord = { ...this.state.data.record };
                                                            newRecord.customerId = selectedOption ? selectedOption.value : null;
                                                            newRecord.customerName = selectedOption ? selectedOption.label : "";
                                                            this.setState(prevState => ({
                                                                data: { ...prevState.data, record: newRecord }
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {this.state.io == 2 && <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="form-label">نوع</label>
                                            <div className="form-control-wrap">
                                                {console.log(this.state.data.record.type)}
                                                <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)}>
                                                    <option value="1">فروش</option>
                                                    <option value="5">برگشت از خرید</option>
                                                    <option value="3">صادرات</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.io == 1 && <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="form-label">نوع</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)}>
                                                    <option value="4">خرید</option>
                                                    <option value="2">برگشت از فروش</option>
                                                    <option value="6">واردات</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>}
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="form-label">تاریخ</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control text-center ltr" type="text" defaultValue={this.state.data.record.datePersian} onChange={e => this.state.data.record.datePersian = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="form-label">شماره</label>
                                            <div className="form-control-wrap">
                                                <NumberFormat value={this.state.data.record.number} onChange={e => this.state.data.record.number = parseInt(e.target.value.replace(/,/g, ''))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' />
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.io == 1 &&
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="form-label">فاکتور خرید</label>
                                                <div className="form-control-wrap">
                                                    <SelectAsync
                                                        style={{ width: "100%" }}
                                                        isMulti={false}
                                                        placeholder="انتخاب فاکتور خرید"
                                                        defaultOptions
                                                        loadOptions={this.loadBuyInvoiceOptions}
                                                        onChange={this.handleBuyInvoiceChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }



                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="form-label">شرح</label>
                                            <div className="form-control-wrap">
                                                <textarea className="form-control" type="text" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane" id="bodies">
                                <table className="table table-ulogs invoceEntryTable">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-center"><span className="overline-title">کالا</span></th>
                                            <th className="text-center" style={{ "width": "120px" }}><span className="overline-title">انبار کالا</span></th>
                                            <th className="text-center" style={{ "width": "80px" }}><span className="overline-title">واحد</span></th>
                                            <th className="text-center" style={{ "width": "60px" }}><span className="overline-title">تعداد/مقدار</span></th>
                                            <th className="text-center" style={{ "width": "80px" }}><span className="overline-title">مبلغ واحد</span></th>
                                            <th className="text-center" style={{ "width": "90px" }}><span className="overline-title">جمع کل</span></th>
                                            <th className="tb-col-action"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.bodies.map(record =>
                                            <tr key={record.id}>
                                                <td>
                                                    <SelectAsync
                                                        defaultValue={record.stuffId > 0 ? [{ value: record.stuffId, label: record.stuffName }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب کالا"
                                                        defaultOptions
                                                        loadOptions={this.loadStuffsOptions}
                                                        onChange={e => this.setBodyValue(record.id, 'stuffId', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <select style={{ "width": "120px" }} className="form-control" type="text" key={record.warehouseId} defaultValue={record.warehouseId} onChange={e => this.setBodyValue(record.id, 'warehouseId', e.target.value)}>
                                                        <option value={this.defaultGuid()}>انتخاب نمایید...</option>
                                                        {this.state.data.warhouses.map(record =>
                                                            <option value={record.id}>{record.title}</option>
                                                        )}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select style={{ "width": "80px" }} className="form-control" type="text" key={record.unitId} defaultValue={record.unitId} onChange={e => this.setBodyValue(record.id, 'unitId', parseInt(e.target.value))}>
                                                        <option value='0'>انتخاب نمایید...</option>
                                                        {this.state.data.units.map(record =>
                                                            <option value={record.id}>{record.name}</option>
                                                        )}
                                                    </select>
                                                </td>
                                                <td>
                                                    <NumberFormat style={{ "width": "60px" }} defaultValue={record.amount} onChange={e => this.setBodyValue(record.id, 'amount', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control' />
                                                </td>
                                                <td>
                                                    <NumberFormat style={{ "width": "80px" }} value={record.price} onChange={e => this.setBodyValue(record.id, 'price', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control' />
                                                </td>
                                                <td><label className="text-center" style={{ "width": "90px" }} key={record.total}>{this.money(record.total)}</label></td>
                                                <td className="tb-col-action"><a onClick={e => this.removeBodyRow(e, record.id)} className="link-cross me-sm-n1 hand"><em className="icon ni ni-cross"></em></a></td>
                                            </tr>
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr style={{ "background-color": "#e9e8e1" }}>
                                            <td colSpan="3" className="text-center">
                                                <b>مجموع آیتم ها</b>
                                            </td>
                                            <td className="text-center">
                                                <labe>{this.money(this.state.t_amount)}</labe>
                                            </td>
                                            <td></td>
                                            <td className="text-center">
                                                <labe>{this.money(this.state.t_total)}</labe>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <a className="btn btn-dim btn-round btn-sm btn-primary hand" onClick={e => this.newBodyRow(e)}><em className="icon ni ni-grid-add-c"></em> <span>افزودن سطر جدید</span></a>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <button type="submit" className="btn btn-primary"><em className="icon ni ni-save"></em> ذخیره</button>
                </div>
            </form>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}